import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { entries } from '../helpers/common';
import { useTranslation } from 'react-i18next';

function SelfSubmittingForm({ method, action, data, ...formProps }) {
  const formRef = useRef();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  useEffect(() => {
    formRef.current.submit();
  }, []);

  return (
    <form
      method={method}
      action={action}
      ref={formRef}
      {...formProps}
    >
      {data &&
        entries(data).map(([name, value], index) => (
          <input key={index} type="hidden" name={name} value={value} />
        ))}

      <input type='hidden' name='lang' value={currentLang} />
    </form>
  );
}

SelfSubmittingForm.propTypes = {
  action: PropTypes.string.isRequired,
  method: PropTypes.oneOf(['POST', 'PUT', 'GET']).isRequired,
};

export default SelfSubmittingForm;
